import { PureComponent } from "react";
import classnames from "classnames";
import { componentStyles } from "./cluster-selection-one-step-component.scss";
import ClusterSelectionItemComponent from "./cluster-selection-item/cluster-selection-item-component";
import ClusterSelectionSignupItemComponent from "./cluster-selection-signup-item/cluster-selection-signup-item-component";
import {
  ELEMENT_DIMENSIONS,
  CLUSTERS_SELECTION_CONFIG,
  OPEN_SIGNUP_ITEM_ANIMATION_DURATION
} from "./clusters-selection-service";
import { CLUSTER_CLICKED } from "constants/bigbrain-event-types";
import { USER_SELECTED_CLUSTER_COOKIE } from "/constants/cookies";
import { setCookie } from "/services/cookies-service";

export default class ClusterSelectionOneStepComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedClusterSelectionItemId: null
    };

    this.ITEM_HEIGHT =
      ELEMENT_DIMENSIONS.CLUSTER_SELECTION_ITEM_HEIGHT + ELEMENT_DIMENSIONS.CLUSTER_SELECTION_ITEM_MARGIN;

    this.selectItem = this.selectItem.bind(this);
    this.clearSelectedItem = this.clearSelectedItem.bind(this);
  }

  selectItem(id) {
    this.setClusterItemZIndex(id, 2);

    this.setState({
      selectedClusterSelectionItemId: id
    });

    BigBrain("track", CLUSTER_CLICKED, { kind: id });

    setCookie(USER_SELECTED_CLUSTER_COOKIE, id);
  }

  clearSelectedItem() {
    const { selectedClusterSelectionItemId } = this.state;

    setTimeout(() => {
      this.setClusterItemZIndex(selectedClusterSelectionItemId, 1);
    }, OPEN_SIGNUP_ITEM_ANIMATION_DURATION);

    this.setState({
      selectedClusterSelectionItemId: null
    });
  }

  setClusterItemZIndex(id, zIndex) {
    document.getElementById(id).style.zIndex = zIndex;
  }

  getClusterSelectionItemsWrapperHeight() {
    const numberOfItems = CLUSTERS_SELECTION_CONFIG.length;

    return numberOfItems * this.ITEM_HEIGHT;
  }

  renderClusterItems() {
    const { selectedClusterSelectionItemId } = this.state;

    return CLUSTERS_SELECTION_CONFIG.map((clusterSelection, index) => {
      const { id } = clusterSelection;
      const isSelected = id === selectedClusterSelectionItemId;
      const style = this.getItemStyle(index, isSelected);
      const Component = isSelected ? ClusterSelectionSignupItemComponent : ClusterSelectionItemComponent;
      const onClick = isSelected ? this.clearSelectedItem : this.selectItem;

      return (
        <div
          key={id}
          id={id}
          className={classnames("cluster-selection-item-component-wrapper", { selected: isSelected })}
          style={style}
        >
          <Component {...clusterSelection} onClick={onClick} />
        </div>
      );
    });
  }

  getItemStyle(index, isSelected) {
    return {
      top: isSelected ? 0 : this.ITEM_HEIGHT * index,
      bottom: isSelected ? 0 : this.ITEM_HEIGHT * (CLUSTERS_SELECTION_CONFIG.length - 1 - index)
    };
  }

  getClusterSelectionItemsWrapperStyle() {
    const clusterSelectionItemsWrapperHeight = this.getClusterSelectionItemsWrapperHeight();
    const clusterSelectionItemsWrapperWidth = ELEMENT_DIMENSIONS.CLUSTER_SELECTION_ITEM_WIDTH;

    return {
      height: clusterSelectionItemsWrapperHeight,
      width: clusterSelectionItemsWrapperWidth
    };
  }

  render() {
    const clusterSelectionItemsWrapperStyle = this.getClusterSelectionItemsWrapperStyle();

    return (
      <div className="cluster-selection-one-step-component">
        <div className="first-title">What would you like to manage ?</div>
        <div className="second-title">You can always change this later</div>

        <div className="cluster-selection-items-wrapper" style={clusterSelectionItemsWrapperStyle}>
          {this.renderClusterItems()}
        </div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
